var getBackgroundHexColor = function (color) {
    switch (color) {
        case "lm-tint-primary":
            return backgroundColors.LightMode.Tint.Primary;
        case "lm-tint-primary-light":
            return backgroundColors.LightMode.Tint.PrimaryLight;
        case "lm-tint-secondary":
            return backgroundColors.LightMode.Tint.Secondary;
        case "lm-tint-secondary-light":
            return backgroundColors.LightMode.Tint.SecondaryLight;
        case "lm-background-primary":
            return backgroundColors.LightMode.Background.Primary;
        case "lm-background-secondary":
            return backgroundColors.LightMode.Background.Secondary;
        case "lm-background-tertiary":
            return backgroundColors.LightMode.Background.Tertiary;
        case "lm-foreground-primary":
            return backgroundColors.LightMode.Foreground.Primary;
        case "lm-foreground-secondary":
            return backgroundColors.LightMode.Foreground.Secondary;
        case "lm-foreground-tertiary":
            return backgroundColors.LightMode.Foreground.Tertiary;
        case "lm-foreground-placeholder":
            return backgroundColors.LightMode.Foreground.Placeholder;
        case "lm-foreground-separation":
            return backgroundColors.LightMode.Foreground.Separation;
        case "lm-foreground-on-primary":
            return backgroundColors.LightMode.Foreground.OnPrimary;
        case "lm-system-stop":
            return backgroundColors.LightMode.System.Stop;
        case "lm-system-wait":
            return backgroundColors.LightMode.System.Wait;
        case "lm-system-go":
            return backgroundColors.LightMode.System.Go;
    }
};
var backgroundColors = {
    LightMode: {
        Tint: {
            Primary: '#0C2AF3',
            PrimaryLight: '#DEEFFF',
            Secondary: '#FD544F',
            SecondaryLight: '#FFEEED'
        },
        Background: {
            Primary: '#F8F9FA',
            Secondary: '#FFFFFF',
            Tertiary: '#F2F4F6'
        },
        Foreground: {
            Primary: '#131313',
            Secondary: '#484848',
            Tertiary: '#6A6A6A',
            Placeholder: '#848484',
            Separation: '#D5D6D8',
            OnPrimary: '#FFFFFF'
        },
        System: {
            Stop: '#FD544F',
            Wait: '#FD8F27',
            Go: '#57BE56'
        }
    },
    DarkMode: {
        NotDoneYet: true
    }
};

export { backgroundColors as b, getBackgroundHexColor as g };
//# sourceMappingURL=backgroundColors-77340375.js.map
